export interface ContactOption {
  id: number;
  firstName?: string;
  lastName?: string;
  preferredName?: string;
  email?: string;
}

export interface TripOption {
  id: number;
  name?: string;
  clientName?: string;
  startDate?: string;
  endDate?: string;
}

export const formatName = (contact?: ContactOption | null) => {
  if (!contact) return 'Unknown contact';
  if (contact.preferredName) return contact.preferredName;

  const fullName = [contact.firstName, contact.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();

  if (fullName.length > 0) return fullName;
  if (contact.email) return contact.email;
  return 'Unknown contact';
};

export const formatTripLabel = (trip?: TripOption | null) => {
  if (!trip) return 'Unknown trip';

  const name = trip.name && trip.name.trim().length > 0 ? trip.name : 'Untitled trip';
  const client = trip.clientName && trip.clientName.trim().length > 0 ? ` • ${trip.clientName}` : '';

  return `${name}${client}`;
};
